import { Injectable } from '@angular/core';
import * as fromUser from './reducers';
import { Store, select } from '@ngrx/store';
import * as UserActionTypes from './actions/user.actions';
import { NewUser } from '../user.interfaces';

@Injectable({
	providedIn: 'root',
})
export class UserStoreService {
	user$ = this.store.pipe(select(fromUser.getUser));
	users$ = this.store.pipe(select(fromUser.getAllUsers));
	usersLoading$ = this.store.pipe(select(fromUser.getUsersLoading));
	usersLoaded$ = this.store.pipe(select(fromUser.getUsersLoaded));
	usersSaving$ = this.store.pipe(select(fromUser.getUsersSaving));
	userError$ = this.store.pipe(select(fromUser.getUserError));

	constructor(private store: Store<fromUser.State>) {}

	dispatchGetMe() {
		this.store.dispatch(new UserActionTypes.GetMe());
	}

	dispatchGetUsersForSite(siteId: string) {
		this.store.dispatch(new UserActionTypes.GetAllUsers(siteId));
	}

	dispatchAddUser(newUser: NewUser) {
		this.store.dispatch(new UserActionTypes.AddUser(newUser));
	}

	dispatchUpdateUser(userId: string, editUser: NewUser) {
		this.store.dispatch(new UserActionTypes.UpdateUser(userId, editUser));
	}

	dispatchDeactivateUser(userId: string, siteId: string) {
		this.store.dispatch(new UserActionTypes.DeactivateUser(userId, siteId));
	}

	dispatchSetDefaultSiteForUser(siteId: string) {
		this.store.dispatch(new UserActionTypes.SetDefaultSiteForUser(siteId));
	}

	acceptEula() {
		this.store.dispatch(new UserActionTypes.AcceptEula());
	}
}
